import { Typography, useMediaQuery } from "@mui/material";
import { theme } from "../styles/mui-theme";

export const SubtitleAtom = ({ subtitle }) => {
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <Typography
      variant="t1"
      textAlign={isMobile ? "center" : "start"}
      zIndex={6}
      sx={{ userSelect: "none" }}
    >
      {subtitle}
    </Typography>
  );
};
